export function sortProfit (a, b, dir) {
  if (dir === null) return 0

  return dir === 'descending' ? +b.upperProfit - +a.upperProfit : +a.upperProfit - +b.upperProfit
}

export function sortPC (a, b, dir) {
  if (dir === null) return 0

  return dir === 'descending' ? Number(b) - Number(a) : Number(a) - Number(b)
}
export function sortName (a, b, dir) {
  if (dir === null) return 0
  const upJudge = a > b ? 1 : -1
  const downJudge = a > b ? -1 : 1

  return dir === 'descending' ? downJudge : upJudge
}
